// colors used by ReportMeter, ParticipantMetricsChartTimeSeries components

const WELLCOACHES_PURPLE = '#5432FF' // rgb(84, 50, 255)
const WELLCOACHES_PINK = '#ED008A'   // rgb(237, 0, 138)
const WELLCOACHES_TEAL = '#00DDE5'   // rgb(0, 221, 229)

const WELLCOACHES_PLOT_BAND_PURPLE = '#5432FF4D' // rgba(84, 50, 255, 0.3)
const WELLCOACHES_PLOT_BAND_PINK = '#ED008A4D'   // rgba(237, 0, 138, 0.3)
const WELLCOACHES_PLOT_BAND_TEAL = '#00DDE54D'   // rgba(0, 221, 229, 0.3)

const GAUGE_COLORS = [
    '#00E81D', // 47DB83 green       // rgb(0, 232, 29)
    '#FFF815', // ffe052 yellow      // rgb(255, 224, 82)
    '#FFAA15', // FF7352 pink        // rgb(255, 170, 21)
    '#EB001B', // E62C00 red         // rgb(230, 44, 0)
]
const GAUGE_DISABLED_COLORS = [
    '#CAF5DB', // green              // rgb(202, 245, 219)
    '#FFF0AE', // yellow             // rgb(255, 240, 174)
    '#FFBAAB', // pink               // rgb(255, 186, 171)
    '#FF6340', // red                // rgb(255, 99, 64)
]
const GAUGE_PLOT_BAND_COLORS = [
    '#00E81D4D', // 47DB83 green       // rgba(0, 232, 29, 0.3)
    '#FFF8154D', // ffe052 yellow      // rgba(255, 224, 82, 0.3)
    '#FFAA154D', // FF7352 pink        // rgba(255, 170, 21, 0.3)
    '#EB001B4D', // E62C00 red         // rgba(230, 44, 0, 0.3)
]
const METRIC_SERIES_COLORS = [
    '#068ec9',                       // rgb(6, 142, 201)
    '#ffbb00',                       // rgb(255, 187, 0)
    '#ea460a',                       // rgb(234, 70, 10)
    '#26b89a',                       // rgb(38, 184, 154)
]
const METRIC_GOAL_LINE_COLOR = '#555555'  // rgb(85, 85, 85)

export default {
    GAUGE_COLORS: GAUGE_COLORS,
    GAUGE_DISABLED_COLORS: GAUGE_DISABLED_COLORS,
    GAUGE_PLOT_BAND_COLORS: GAUGE_PLOT_BAND_COLORS,
    METRIC_SERIES_COLORS: METRIC_SERIES_COLORS,
    METRIC_GOAL_LINE_COLOR: METRIC_GOAL_LINE_COLOR,

    CUSTOM_GAUGE_COLORS: {
        default: GAUGE_COLORS,
        wellcoaches: [ // = custom theme name
            WELLCOACHES_TEAL, // "green"
            WELLCOACHES_PINK, // "yellow"
            WELLCOACHES_PURPLE, // "pink"
        ]
    },
    CUSTOM_GAUGE_PLOT_BAND_COLORS: {
        default: GAUGE_PLOT_BAND_COLORS,
        wellcoaches: [
            WELLCOACHES_PLOT_BAND_TEAL,
            WELLCOACHES_PLOT_BAND_PINK,
            WELLCOACHES_PLOT_BAND_PURPLE,
            '#9999994D', // TODO add a 4th color for wellcoaches theme
        ]
    },
    // TODO: add CUSTOM_GAUGE_DISABLED_COLORS?

    // not gauge colors per se, but might be useful somewhere
    WELLCOACHES_PURPLE: WELLCOACHES_PURPLE,
    WELLCOACHES_PINK: WELLCOACHES_PINK,
    WELLCOACHES_TEAL: WELLCOACHES_TEAL,

    WELLCOACHES_PLOT_BAND_PURPLE: WELLCOACHES_PLOT_BAND_PURPLE,
    WELLCOACHES_PLOT_BAND_PINK: WELLCOACHES_PLOT_BAND_PINK,
    WELLCOACHES_PLOT_BAND_TEAL: WELLCOACHES_PLOT_BAND_TEAL,

}
